export default __webpack_public_path__ + "static/media/spade-img.e56818d8.webp";